export const listCopyIt = {
    published: "Pubblicato",
    draft: "Bozza",
    name: "Nome",
    role: "Ruolo",
    organisation: "Organizzazione",
    email: "E-mail",
    dateOfBirth: "Data di nascita",
    labels: "Etichette",
    status: "Stato",
    actions: "Azioni",
};
